import { KatLitFilteredElement, register } from '../../shared/base';
import { KatMetric } from './';

/**
 * @component {kat-metric-visualization} KatMetricVisualization Component used to place and filter visualization components within the metric component.
 */
@register(KatMetric.slotMapping.visualization.name)
export class KatMetricVisualization extends KatLitFilteredElement {
  constructor() {
    super(
      KatMetric.slotMapping.visualization.name,
      KatMetric.slotMapping.visualization.allowed
    );
  }
}
